import { Remarks } from '../Remarks';
import { Quotation } from '../Quotation';
import { VendorDetails } from '../VendorDetails';
import { VendorPopupTab } from '../VendorPopupTab.enum';

const TabContent: React.FC<{
  selectedTab: VendorPopupTab;
  vendorId: number;
}> = ({ selectedTab, vendorId }) => {
  switch (selectedTab) {
    case VendorPopupTab.VendorDetails:
      return <VendorDetails vendorId={vendorId} />;
    case VendorPopupTab.Quotation:
      return <Quotation vendorId={vendorId} />;
    case VendorPopupTab.Remarks:
      return <Remarks vendorId={vendorId} />;
    default:
      return null;
  }
};

export default TabContent;
